import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { contentsAPI } from '@/utils/contentsApi';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import OtherBrandsSlider from '../Slider/OtherBrandsSlider';

function HomepageOtherBrandCarousel({ section }) {
  const pathName = usePathname();
  const [data, setData] = useState([]);
  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPI(contentsData);
        setData([...response]);
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  // will not visible if data is empty
  if (Array.isArray(data) && data?.length === 0) {
    return null;
  }

  if (!Array.isArray(data) || data?.length === 0) {
    return null;
  }

  return (
    <div className="mb-24 lg:mb-[40px]">
      <DynamicSectionTitle
        text={section?.title[selectLang]}
        className={cn({
          'text-center': pathName === '/',
        })}
      />
      <OtherBrandsSlider data={data} />
    </div>
  );
}

export default HomepageOtherBrandCarousel;
